// extracted by mini-css-extract-plugin
export default {"adContainer":"TopLeaderboardAd_adContainer__OSxr3","blankSpace":"TopLeaderboardAd_blankSpace__OqCVj","ad":"TopLeaderboardAd_ad__kDdf5","adImage":"TopLeaderboardAd_adImage__tiFWl"};